var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 36,
    viewBox: "0 0 37 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.5003 9.36328C23.2688 9.36328 27.1373 13.2318 27.1373 18.0003C27.1373 22.7688 23.2688 26.6373 18.5003 26.6373C13.7318 26.6373 9.86328 22.7688 9.86328 18.0003C9.86328 13.2318 13.7318 9.36328 18.5003 9.36328Z",
    fill: "#E8184C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 27.7361C13.1149 27.7361 8.7591 23.3555 8.7591 17.9953C8.7591 12.635 13.1397 8.25438 18.5 8.25438C23.8602 8.25438 28.2408 12.6301 28.2408 17.9953C28.2408 23.3605 23.885 27.7361 18.5 27.7361ZM18.5 7.52344C12.7171 7.52344 8.02319 12.2174 8.02319 18.0002C8.02319 23.7831 12.7171 28.477 18.5 28.477C24.2828 28.477 28.9768 23.7831 28.9768 18.0002C28.9768 12.2174 24.2828 7.52344 18.5 7.52344Z",
    fill: "#E8184C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5054 14.2662C18.933 14.2662 19.2811 13.9182 19.2811 13.4905C19.2811 13.0629 18.933 12.7148 18.5054 12.7148C18.0778 12.7148 17.7297 13.0629 17.7297 13.4905C17.7297 13.9182 18.0778 14.2662 18.5054 14.2662Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.505 15.4248C18.2514 15.4248 18.0525 15.6237 18.0525 15.8773V23.0524C18.0525 23.306 18.2514 23.5049 18.505 23.5049C18.7586 23.5049 18.9575 23.306 18.9575 23.0524V15.8773C18.9575 15.6336 18.7437 15.4248 18.505 15.4248Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.25e5e5c3.svg";
export { ForwardRef as ReactComponent };